export enum enumIDType {
  'RSA ID' = 1,
  Passport,
  'Date of Birth',
  'Namibia ID',
  Business,
  Other,
  Internal,
  'Asylum Seeker',
  Refugee,
  Option1,
  Option2
}

export namespace enumIDType {
  export function values() {
    return Object.keys(enumIDType).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
